export const homeStats = [
  { value: '150+', label: 'Projects Delivered' },
  { value: '98%', label: 'Client Satisfaction' },
  { value: '25+', label: 'Tech Experts' },
  { value: '5+', label: 'Years Experience' },
];

export const whyUsData = [
  { id: 'agile', title: 'Future-Proof Engineering', desc: 'We build with technologies that scale and evolve, ensuring your digital investment lasts for years.' },
  { id: 'innovation', title: 'AI-Native Workflow', desc: 'Integrating artificial intelligence into our processes to deliver smarter, more efficient solutions.' },
  { id: 'security', title: 'Cloud-First Architecture', desc: 'Leveraging AWS and GCP for infinitely scalable, resilient, and enterprise-grade infrastructure.' },
  { id: 'partnership', title: 'Transparent Partnership', desc: 'We work as an extension of your team, providing full visibility into every sprint and milestone.' },
];
